// import React, { useState, useEffect, useContext, useCallback } from "react";
// import { DataGrid } from "@mui/x-data-grid";
// import {
//   Modal,
//   TextField,
//   Box,
//   Typography,
//   Grid,
//   Paper,
//   Button,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   IconButton,
//   Snackbar,
//   Alert,
//   CircularProgress,
//   Card,
//   Stack,
//   Chip,
//   Avatar,
//   useTheme,
//   alpha,
//   LinearProgress,
//   Skeleton,
//   Container,
//   InputAdornment,
//   Tooltip,
//   Accordion,
//   AccordionSummary,
//   AccordionDetails,
//   useMediaQuery,
// } from "@mui/material";
// import {
//   MdSearch,
//   MdClear,
//   MdPerson,
//   MdPhone,
//   MdEmail,
//   MdLocationOn,
//   MdEdit,
//   MdDelete,
//   MdClose,
//   MdError,
//   MdInfo,
//   MdDownload,
//   MdNotifications,
//   MdAccountBalanceWallet,
//   MdExpandMore,
//   MdCalendarToday,
//   MdAccessTime,
//   MdAttachMoney,
//   MdLocalPharmacy,
//   MdDeliveryDining,
//   MdPayment,
//   MdVerified,
//   MdFilterList,
//   MdGroup,
//   MdLocationCity,
//   MdTrendingUp,
// } from "react-icons/md";
// import { AiFillDelete } from "react-icons/ai";
// import { FaInfoCircle, FaLocationArrow } from "react-icons/fa";
// import { BiPencil } from "react-icons/bi";
// import axios from "axios";
// import { MyContext } from "Contextapi/MyContext";
// import { useNavigate } from "react-router-dom";
// import MyLocation from "Contextapi/MyLocation";
// import CloseIcon from "@mui/icons-material/Close";
// import Usertotal from "./Usertotal";
// import HeatmapComponent from "./HeatmapComponent";
// import { toast } from "react-toastify";
// import SendnotificationByPinCode from "./SendnotificationByPinCode";
// import dayjs from "dayjs";
// import UserActivityModal from "./UserActivityModal";

// const UserDetails = () => {
//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down("md"));
//   const navigate = useNavigate();
//   const [searchText, setSearchText] = useState("");
//   const [usersData, setUsersData] = useState([]);
//   const { setUsercount } = useContext(MyContext);
//   const [open, setOpen] = useState(false);
//   const [selectedUserDetails, setSelectedUserDetails] = useState(null);
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState(null);
//   const [deleteOpen, setDeleteOpen] = useState(false);
//   const [selectedUserId, setSelectedUserId] = useState(null);
//   const [sendnotificationopenmodel, setSendnotificationopenmodel] =
//     useState(false);
//   const [searchLoading, setSearchLoading] = useState(false);
//   const [modalOpen, setModalOpen] = useState(false);
//   const [formData, setFormData] = useState({
//     msg: "",
//     title: "",
//     details: "",
//     urls: "",
//   });
//   const [paginationModel, setPaginationModel] = useState({
//     page: 0, // MUI uses 0-based index
//     pageSize: 10, // default
//   });

//   const [rowCount, setRowCount] = useState(0);
//   const [notifybox, setNotifybox] = useState(false);

//   // Medstown brand colors
//   const medstownColors = {
//     primary: "#014D4D",
//     secondary: "#02A0A0",
//     accent: "#FFB800",
//     success: "#4caf50",
//     error: "#f44336",
//     warning: "#ff9800",
//   };

// const fetchUsers = useCallback(async (pageNum = 1, limit = 10) => {
//   try {
//     setLoading(true);
//     const res = await axios.get(
//       `https://api.medstown.com/customer/users/list?page=${pageNum}&limit=${limit}`
//     );
//     setUsersData(res.data.data?.list || []);
//     setRowCount(res.data.data?.totalCount || 0);
//   } catch (error) {
//     console.error("Error fetching users:", error);
//   } finally {
//     setLoading(false);
//   }
// }, []);

// useEffect(() => {
//   fetchUsers(paginationModel.page + 1, paginationModel.pageSize);
// }, [fetchUsers, paginationModel.page, paginationModel.pageSize]);

//   const handleSearchTextChange = (event) => {
//     setSearchText(event.target.value);
//     setSearchLoading(true);
//     setTimeout(() => setSearchLoading(false), 300);
//   };

//   const clearSearch = () => {
//     setSearchText("");
//   };

//   const filteredRows = usersData.filter((row) =>
//     Object.values(row).some(
//       (value) =>
//         value &&
//         value.toString().toLowerCase().includes(searchText.toLowerCase())
//     )
//   );

//   const handleClose = () => {
//     setOpen(false);
//     setSelectedUserDetails(null);
//   };

//   const handledetailsClick = async (userId) => {
//     try {
//       setLoading(true);
//       const res = await axios.get(
//         `https://api.medstown.com/customer/getuser/allorder/${userId}`
//       );
//       setSelectedUserDetails(res.data);
//       setOpen(true);
//     } catch (error) {
//       setError("Failed to fetch user details");
//       console.error("Error fetching user details:", error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleLocationClick = (lat, long) => {
//     if (!lat || !long) {
//       setError("Invalid location coordinates");
//       return;
//     }
//     const googleMapsUrl = `https://www.google.com/maps?q=${lat},${long}`;
//     window.open(googleMapsUrl, "_blank");
//   };

//   const handleDeleteClose = () => {
//     setDeleteOpen(false);
//     setSelectedUserId(null);
//   };

//   const handleDeleteUser = async () => {
//     if (!selectedUserId) return;

//     try {
//       setLoading(true);
//       await axios.delete(
//         `https://api.medstown.com/customer/deleteuser/${selectedUserId}`
//       );

//       setUsersData((prev) =>
//         prev.filter((user) => user._id !== selectedUserId)
//       );
//       setUsercount((prev) => prev - 1);

//       toast.success("User deleted successfully.");
//     } catch (error) {
//       console.error("Delete error:", error);
//       setError("Failed to delete user.");
//       toast.error("Failed to delete user. Please try again.");
//     } finally {
//       setLoading(false);
//       handleDeleteClose();
//     }
//   };

//   const handleDownload = () => {
//     try {
//       window.location.href =
//         "https://api.medstown.com/admin/users/download-csv";
//     } catch (error) {
//       setError("Failed to download CSV");
//       console.error("Download error:", error);
//     }
//   };

//   const handleChange = (e) => {
//     setFormData({
//       ...formData,
//       [e.target.name]: e.target.value,
//     });
//   };

//   const handleSendNotification = async () => {
//     if (!searchText.match(/^\d{6}$/)) {
//       setError("Please enter a valid 6-digit pincode");
//       return;
//     }
//     try {
//       await axios.post(
//         `https://api.medstown.com/customer/userspincode/${searchText}/notiy`,
//         formData
//       );
//       setFormData({
//         msg: "",
//         title: "",
//         details: "",
//         urls: "",
//       });
//       setNotifybox(false);
//       setError(null);
//       alert(`Notification is running successfully pincode-${searchText}`);
//     } catch (error) {
//       setError(error.response?.data?.message || "Failed to send notification");
//     }
//   };

//   // Enhanced table columns with Medstown styling
//   const tableColumns = [
//     {
//       field: "fullName",
//       headerName: "User Details",
//       width: 250,
//       renderCell: (params) => (
//         <Stack spacing={0.5} sx={{ py: 0.5 }}>
//           <Stack direction="row" alignItems="center" spacing={1}>
//             <Avatar
//               sx={{
//                 backgroundColor: alpha(medstownColors.primary, 0.1),
//                 color: medstownColors.primary,
//                 width: 28,
//                 height: 28,
//               }}
//             >
//               <MdPerson size={16} />
//             </Avatar>
//             <Box>
//               <Typography
//                 variant="body2"
//                 fontWeight={700}
//                 sx={{ fontSize: "0.8rem" }}
//               >
//                 {params.value || "N/A"}
//               </Typography>
//               <Typography
//                 variant="caption"
//                 sx={{
//                   fontSize: "0.7rem",
//                   color: "text.secondary",
//                   fontFamily: "monospace",
//                 }}
//               >
//                 ID: {params.row.userId || "N/A"}
//               </Typography>
//             </Box>
//           </Stack>
//         </Stack>
//       ),
//     },
//     {
//       field: "phone",
//       headerName: "Contact",
//       width: 140,
//       renderCell: (params) => (
//         <Stack spacing={0.3}>
//           <Stack direction="row" alignItems="center" spacing={1}>
//             <MdPhone size={14} color={medstownColors.secondary} />
//             <Typography
//               variant="body2"
//               sx={{
//                 fontFamily: "monospace",
//                 fontSize: "0.75rem",
//               }}
//             >
//               {params.value || "N/A"}
//             </Typography>
//           </Stack>
//           <Stack direction="row" alignItems="center" spacing={1}>
//             <MdEmail size={14} color={theme.palette.text.secondary} />
//             <Typography
//               variant="caption"
//               sx={{
//                 fontSize: "0.65rem",
//                 color: "text.secondary",
//                 overflow: "hidden",
//                 textOverflow: "ellipsis",
//                 whiteSpace: "nowrap",
//               }}
//             >
//               {params.row.email || "N/A"}
//             </Typography>
//           </Stack>
//         </Stack>
//       ),
//     },
//     {
//       field: "pincode",
//       headerName: "Pincode",
//       width: 100,
//       renderCell: (params) => (
//         <Stack direction="row" alignItems="center" spacing={1}>
//           <MdLocationCity size={14} color={medstownColors.accent} />
//           <Chip
//             label={params.value || "N/A"}
//             size="small"
//             sx={{
//               fontSize: "0.7rem",
//               height: 20,
//               backgroundColor: alpha(medstownColors.accent, 0.1),
//               color: medstownColors.accent,
//             }}
//           />
//         </Stack>
//       ),
//     },
//     {
//       field: "address",
//       headerName: "Location",
//       width: 250,
//       renderCell: (params) => (
//         <Stack direction="row" alignItems="center" spacing={1}>
//           <MdLocationOn size={14} color={medstownColors.secondary} />
//           <Typography
//             variant="body2"
//             sx={{
//               fontSize: "0.75rem",
//               overflow: "hidden",
//               textOverflow: "ellipsis",
//               display: "-webkit-box",
//               WebkitLineClamp: 2,
//               WebkitBoxOrient: "vertical",
//             }}
//           >
//             {params?.row?.address
//               ? `${params?.row?.address?.street || ""} ${
//                   params?.row?.address?.district || ""
//                 } ${params?.row?.address?.city || ""} ${
//                   params?.row?.address?.region || ""
//                 } ${params?.row?.address?.postalCode || ""}`
//               : "N/A"}
//           </Typography>
//         </Stack>
//       ),
//     },
//     {
//       field: "datetime",
//       headerName: "Registration",
//       width: 180,
//       renderCell: (params) => {
//         const date = new Date(params.value || null);
//         return (
//           <Stack spacing={0.3}>
//             <Stack direction="row" alignItems="center" spacing={0.5}>
//               <MdCalendarToday size={12} color={theme.palette.text.secondary} />
//               <Typography
//                 variant="caption"
//                 sx={{ fontSize: "0.7rem", fontWeight: 500 }}
//               >
//                 {date ? dayjs(date).format("MMM DD, YYYY") : "N/A"}
//               </Typography>
//             </Stack>
//             <Stack direction="row" alignItems="center" spacing={0.5}>
//               <MdAccessTime size={12} color={theme.palette.text.secondary} />
//               <Typography
//                 variant="caption"
//                 sx={{
//                   fontSize: "0.65rem",
//                   color: "text.secondary",
//                 }}
//               >
//                 {date ? dayjs(date).format("hh:mm A") : "N/A"}
//               </Typography>
//             </Stack>
//           </Stack>
//         );
//       },
//     },
//     {
//       field: "Action",
//       headerName: "Actions",
//       width: 200,
//       renderCell: (params) => (
//         <Stack direction="row" spacing={0.5}>
//           {/* <Tooltip title="View Details">
//             <IconButton
//               size="small"
//               onClick={() => handledetailsClick(params?.row?.userId)}
//               sx={{
//                 color: medstownColors.primary,
//                 backgroundColor: alpha(medstownColors.primary, 0.1),
//                 width: 24,
//                 height: 24,
//                 "&:hover": {
//                   backgroundColor: alpha(medstownColors.primary, 0.2),
//                 },
//               }}
//             >
//               <FaInfoCircle size={12} />
//             </IconButton>
//           </Tooltip> */}

//           <Tooltip title="Delete User">
//             <IconButton
//               size="small"
//               onClick={() => {
//                 const userId = params?.row?._id;
//                 if (!userId) {
//                   toast.error("User ID is missing.");
//                   return;
//                 }
//                 setSelectedUserId(userId);
//                 setDeleteOpen(true);
//               }}
//               sx={{
//                 color: medstownColors.error,
//                 backgroundColor: alpha(medstownColors.error, 0.1),
//                 width: 30,
//                 height: 30,
//                 "&:hover": {
//                   backgroundColor: alpha(medstownColors.error, 0.2),
//                 },
//               }}
//             >
//               <AiFillDelete size={12} />
//             </IconButton>
//           </Tooltip>

//           {params?.row?.address?.latitude && (
//             <Tooltip title="View Location">
//               <IconButton
//                 size="small"
//                 onClick={() =>
//                   handleLocationClick(
//                     params?.row?.address?.latitude,
//                     params?.row?.address?.longitude
//                   )
//                 }
//                 sx={{
//                   color: medstownColors.secondary,
//                   backgroundColor: alpha(medstownColors.secondary, 0.1),
//                   width: 30,
//                   height: 30,
//                   "&:hover": {
//                     backgroundColor: alpha(medstownColors.secondary, 0.2),
//                   },
//                 }}
//               >
//                 <FaLocationArrow size={12} />
//               </IconButton>
//             </Tooltip>
//           )}
//           {/* user activity button */}
//           {/* <Tooltip title="User Activity">
//             <IconButton
//               size="small"
//               // onClick={() => navigate(`/admin/user-activity/${params?.row?.userId}`)}
//               sx={{
//                 color: medstownColors.warning,
//                 backgroundColor: alpha(medstownColors.warning, 0.1),
//                 width: 24,
//                 height: 24,
//                 "&:hover": {
//                   backgroundColor: alpha(medstownColors.warning, 0.2),
//                 },
//               }}
//             >
//               <MdTrendingUp size={12} />
//             </IconButton>
//           </Tooltip> */}
//           {/* <Button>User Profile</Button> */}
//           <Tooltip title="User Activity">
//             <IconButton
//               size="small"
//               onClick={() =>
//                 navigate(`/admin/user-activity/${params?.row?.userId}`)
//               }
//               sx={{
//                 color: medstownColors.warning,
//                 backgroundColor: alpha(medstownColors.warning, 0.1),
//                 width: 30,
//                 height: 30,
//                 "&:hover": {
//                   backgroundColor: alpha(medstownColors.warning, 0.2),
//                 },
//               }}
//             >
//               <MdTrendingUp size={25} />
//             </IconButton>
//           </Tooltip>
//         </Stack>
//       ),
//     },
//   ];

//   if (loading) {
//     return (
//       <Container maxWidth="xl" sx={{ py: 2 }}>
//         <Card sx={{ borderRadius: 2, overflow: "hidden" }}>
//           <Box sx={{ p: 2 }}>
//             <Skeleton
//               variant="rectangular"
//               height={50}
//               sx={{ borderRadius: 1.5, mb: 1.5 }}
//             />
//           </Box>
//           <Stack spacing={1.5} sx={{ p: 2 }}>
//             {Array.from(new Array(8)).map((_, index) => (
//               <Skeleton
//                 key={index}
//                 variant="rectangular"
//                 height={60}
//                 sx={{ borderRadius: 1 }}
//               />
//             ))}
//           </Stack>
//         </Card>
//       </Container>
//     );
//   }

//   return (
//     <Container maxWidth={false} sx={{ width: "100%", py: 2 }}>
//       {/* Enhanced Header with Advanced Design */}
//       {!isMobile ? (
//         <Paper
//           elevation={0}
//           sx={{
//             p: 3,
//             mb: 2,
//             borderRadius: 3,
//             background: `linear-gradient(135deg, ${medstownColors.primary}, ${medstownColors.secondary})`,
//             color: "white",
//             position: "relative",
//             overflow: "hidden",
//           }}
//         >
//           {/* Advanced Background Pattern */}
//           <Box
//             sx={{
//               position: "absolute",
//               top: 0,
//               right: 0,
//               width: "100%",
//               height: "100%",
//               opacity: 0.15,
//               background: `
//               radial-gradient(circle at 20% 80%, rgba(255, 255, 255, 0.1) 0%, transparent 50%),
//               radial-gradient(circle at 80% 20%, rgba(255, 255, 255, 0.1) 0%, transparent 50%),
//               linear-gradient(45deg, rgba(255, 255, 255, 0.05) 25%, transparent 25%),
//               linear-gradient(-45deg, rgba(255, 255, 255, 0.05) 25%, transparent 25%),
//               linear-gradient(45deg, transparent 75%, rgba(255, 255, 255, 0.05) 75%),
//               linear-gradient(-45deg, transparent 75%, rgba(255, 255, 255, 0.05) 75%)
//             `,
//               backgroundSize: "60px 60px",
//             }}
//           />

//           <Stack
//             direction="row"
//             alignItems="center"
//             spacing={3}
//             sx={{ position: "relative", zIndex: 1 }}
//           >
//             {/* Enhanced Logo/Icon */}
//             <Box sx={{ position: "relative" }}>
//               <Avatar
//                 sx={{
//                   backgroundColor: alpha("#ffffff", 0.2),
//                   color: "white",
//                   width: 56,
//                   height: 56,
//                   boxShadow: `0 8px 24px ${alpha("#000000", 0.15)}`,
//                 }}
//               >
//                 <MdGroup size={28} />
//               </Avatar>
//             </Box>

//             {/* Enhanced Title Section */}
//             <Box sx={{ flexGrow: 1 }}>
//               <Typography
//                 variant="h4"
//                 fontWeight={900}
//                 sx={{
//                   mb: 0.5,
//                   textShadow: "0 2px 4px rgba(0,0,0,0.1)",
//                   letterSpacing: "-0.5px",
//                 }}
//               >
//                 User Management Hub
//               </Typography>
//               <Typography
//                 variant="body1"
//                 sx={{
//                   opacity: 0.9,
//                   fontSize: "1.1rem",
//                   fontWeight: 400,
//                 }}
//               >
//                 Comprehensive user analytics, order tracking, and notification
//                 management
//               </Typography>
//             </Box>

//             {/* Enhanced Stats Section */}
//             <Box textAlign="right">
//               <Stack spacing={1} alignItems="flex-end">
//                 <Box>
//                   <Typography
//                     variant="caption"
//                     sx={{ opacity: 0.8, fontSize: "0.8rem" }}
//                   >
//                     Total Users
//                   </Typography>
//                   <Typography
//                     variant="h3"
//                     fontWeight={800}
//                     sx={{
//                       lineHeight: 1,
//                       textShadow: "0 2px 4px rgba(0,0,0,0.1)",
//                     }}
//                   >
//                     {filteredRows.length}
//                   </Typography>
//                 </Box>

//               </Stack>
//             </Box>
//           </Stack>
//         </Paper>
//       ) : (
//         <Paper
//           elevation={0}
//           sx={{
//             p: 3,
//             mb: 2,
//             borderRadius: 3,
//             background: `linear-gradient(135deg, ${medstownColors.primary}, ${medstownColors.secondary})`,
//             color: "white",
//             position: "relative",
//             overflow: "hidden",
//           }}
//         >
//           <Box sx={{ display: "flex", gap: 2 }}>
//             <Avatar
//               sx={{
//                 backgroundColor: alpha("#ffffff", 0.2),
//                 color: "white",
//                 width: 40,
//                 height: 40,
//                 boxShadow: `0 8px 24px ${alpha("#000000", 0.15)}`,
//               }}
//             >
//               <MdGroup size={28} />
//             </Avatar>
//             <Box sx={{ flexGrow: 1 }}>
//               <Typography
//                 variant="h5"
//                 fontWeight={500}
//                 sx={{
//                   mt: 1.8,
//                   fontSize: "14px",
//                   textShadow: "0 2px 4px rgba(0,0,0,0.1)",
//                   letterSpacing: "-0.5px",
//                 }}
//               >
//                 User Management Hub
//               </Typography>
//             </Box>
//           </Box>
//         </Paper>
//       )}

//       {/* Error Snackbar */}
//       <Snackbar
//         open={!!error}
//         autoHideDuration={6000}
//         onClose={() => setError(null)}
//       >
//         <Alert severity="error" sx={{ width: "100%" }}>
//           {error}
//         </Alert>
//       </Snackbar>

//       {/* Dashboard Components */}
//       <Grid container spacing={2} sx={{ mb: 2 }}>
//         <Grid item xs={12}>
//           <Usertotal />
//         </Grid>
//         <Grid item xs={12}>
//           <HeatmapComponent />
//         </Grid>
//       </Grid>

//       {/* Enhanced Action Buttons Section */}
//       <Card
//         elevation={0}
//         sx={{
//           borderRadius: 2,
//           border: `1px solid ${alpha(medstownColors.primary, 0.08)}`,
//           mb: 2,
//         }}
//       >
//         <Box sx={{ p: 2 }}>
//           <Grid container spacing={2} alignItems="center">
//             {/* Search Field */}
//             <Grid item xs={12} md={6}>
//               <TextField
//                 variant="outlined"
//                 size="medium"
//                 fullWidth
//                 placeholder="Search users, phone, email, pincode..."
//                 value={searchText}
//                 onChange={handleSearchTextChange}
//                 sx={{
//                   "& .MuiOutlinedInput-root": {
//                     backgroundColor: alpha(theme.palette.background.paper, 0.8),
//                     borderRadius: 2,
//                     "& fieldset": {
//                       borderColor: alpha(medstownColors.primary, 0.2),
//                     },
//                     "&:hover fieldset": {
//                       borderColor: alpha(medstownColors.primary, 0.4),
//                     },
//                     "&.Mui-focused fieldset": {
//                       borderColor: medstownColors.primary,
//                     },
//                   },
//                 }}
//                 InputProps={{
//                   startAdornment: (
//                     <InputAdornment position="start">
//                       {searchLoading ? (
//                         <LinearProgress
//                           sx={{ width: 18, height: 2, borderRadius: 1 }}
//                         />
//                       ) : (
//                         <MdSearch size={18} color={medstownColors.primary} />
//                       )}
//                     </InputAdornment>
//                   ),
//                   endAdornment: searchText && (
//                     <InputAdornment position="end">
//                       <IconButton
//                         size="small"
//                         onClick={clearSearch}
//                         sx={{ width: 24, height: 24 }}
//                       >
//                         <MdClear size={16} />
//                       </IconButton>
//                     </InputAdornment>
//                   ),
//                 }}
//               />
//             </Grid>

//             {/* Action Buttons */}
//             {!isMobile ? (
//               // Desktop Layout - All buttons in a single row
//               <Grid item xs={12} md={6}>
//                 <Stack
//                   direction="row"
//                   spacing={1}
//                   justifyContent="flex-end"
//                   flexWrap="wrap"
//                 >
//                   <Button
//                     variant="contained"
//                     startIcon={<MdDownload size={16} />}
//                     onClick={handleDownload}
//                     sx={{
//                       backgroundColor: medstownColors.primary,
//                       "&:hover": {
//                         backgroundColor: alpha(medstownColors.primary, 0.8),
//                       },
//                       borderRadius: 2,
//                       px: 2,
//                       py: 1,
//                     }}
//                   >
//                     CSV
//                   </Button>
//                   <Button
//                     variant="contained"
//                     startIcon={<MdNotifications size={16} />}
//                     onClick={() => setNotifybox(true)}
//                     sx={{
//                       backgroundColor: medstownColors.secondary,
//                       "&:hover": {
//                         backgroundColor: alpha(medstownColors.secondary, 0.8),
//                       },
//                       borderRadius: 2,
//                       px: 2,
//                       py: 1,
//                     }}
//                   >
//                     Notify
//                   </Button>
//                   <Button
//                     variant="contained"
//                     startIcon={<MdAccountBalanceWallet size={16} />}
//                     onClick={() => navigate("/admin/add-wallet-amount")}
//                     sx={{
//                       backgroundColor: medstownColors.accent,
//                       "&:hover": {
//                         backgroundColor: alpha(medstownColors.accent, 0.8),
//                       },
//                       borderRadius: 2,
//                       px: 2,
//                       py: 1,
//                       color: "white",
//                     }}
//                   >
//                     Add Cash
//                   </Button>
//                   <Button
//                     variant="contained"
//                     startIcon={<MdLocationCity size={16} />}
//                     onClick={() => setSendnotificationopenmodel(true)}
//                     sx={{
//                       backgroundColor: medstownColors.success,
//                       "&:hover": {
//                         backgroundColor: alpha(medstownColors.success, 0.8),
//                       },
//                       borderRadius: 2,
//                       px: 2,
//                       py: 1,
//                     }}
//                   >
//                     Pin Notify
//                   </Button>
//                 </Stack>
//               </Grid>
//             ) : (
//               // Mobile Layout - 2x2 Grid
//               <Grid item xs={12} md={6}>
//                 <Grid container spacing={1}>
//                   {/* First Row */}
//                   <Grid item xs={6}>
//                     <Button
//                       variant="contained"
//                       startIcon={<MdDownload size={14} />}
//                       onClick={handleDownload}
//                       fullWidth
//                       size="small"
//                       sx={{
//                         backgroundColor: medstownColors.primary,
//                         "&:hover": {
//                           backgroundColor: alpha(medstownColors.primary, 0.8),
//                         },
//                         borderRadius: 2,
//                         px: 1.5,
//                         py: 0.75,
//                         fontSize: "0.75rem",
//                       }}
//                     >
//                       CSV
//                     </Button>
//                   </Grid>
//                   <Grid item xs={6}>
//                     <Button
//                       variant="contained"
//                       startIcon={<MdNotifications size={14} />}
//                       onClick={() => setNotifybox(true)}
//                       fullWidth
//                       size="small"
//                       sx={{
//                         backgroundColor: medstownColors.secondary,
//                         "&:hover": {
//                           backgroundColor: alpha(medstownColors.secondary, 0.8),
//                         },
//                         borderRadius: 2,
//                         px: 1.5,
//                         py: 0.75,
//                         fontSize: "0.75rem",
//                       }}
//                     >
//                       Notify
//                     </Button>
//                   </Grid>

//                   {/* Second Row */}
//                   <Grid item xs={6}>
//                     <Button
//                       variant="contained"
//                       startIcon={<MdAccountBalanceWallet size={14} />}
//                       onClick={() => navigate("/admin/add-wallet-amount")}
//                       fullWidth
//                       size="small"
//                       sx={{
//                         backgroundColor: medstownColors.accent,
//                         "&:hover": {
//                           backgroundColor: alpha(medstownColors.accent, 0.8),
//                         },
//                         borderRadius: 2,
//                         px: 1.5,
//                         py: 0.75,
//                         color: "white",
//                         fontSize: "0.75rem",
//                       }}
//                     >
//                       Add Cash
//                     </Button>
//                   </Grid>
//                   <Grid item xs={6}>
//                     <Button
//                       variant="contained"
//                       startIcon={<MdLocationCity size={14} />}
//                       onClick={() => setSendnotificationopenmodel(true)}
//                       fullWidth
//                       size="small"
//                       sx={{
//                         backgroundColor: medstownColors.success,
//                         "&:hover": {
//                           backgroundColor: alpha(medstownColors.success, 0.8),
//                         },
//                         borderRadius: 2,
//                         px: 1.5,
//                         py: 0.75,
//                         fontSize: "0.75rem",
//                       }}
//                     >
//                       Pin Notify
//                     </Button>
//                   </Grid>
//                 </Grid>
//               </Grid>
//             )}
//           </Grid>
//         </Box>
//       </Card>

//       {/* Enhanced Data Grid Section */}
//       <Card
//         elevation={0}
//         sx={{
//           borderRadius: 2,
//           border: `1px solid ${alpha(medstownColors.primary, 0.08)}`,
//           overflow: "hidden",
//         }}
//       >
//         <Box
//           sx={{
//             p: 2,
//             backgroundColor: alpha(medstownColors.primary, 0.06),
//             borderBottom: `1px solid ${alpha(medstownColors.primary, 0.1)}`,
//           }}
//         >
//           <Stack direction="row" alignItems="center" spacing={1.5}>
//             <Avatar
//               sx={{
//                 backgroundColor: alpha(medstownColors.primary, 0.1),
//                 color: medstownColors.primary,
//                 width: 32,
//                 height: 32,
//               }}
//             >
//               <MdFilterList size={18} />
//             </Avatar>
//             <Typography variant="h6" fontWeight={700} color="primary.main">
//               User Database
//             </Typography>
//             <Typography variant="caption" color="text.secondary">
//               Complete user information, order history, and activity tracking
//             </Typography>
//           </Stack>
//         </Box>

//         {/* Data Grid */}
//         <Box sx={{ height: 600, px: 2, pb: 2 }}>
//           {usersData.length > 0 ? (
//             <DataGrid
//               rows={usersData}
//               columns={tableColumns}
//               getRowId={(row) => row._id}
//               paginationMode="server"
//               rowCount={rowCount}
//               pageSizeOptions={[5, 10, 20]}
//               paginationModel={paginationModel}
//               onPaginationModelChange={setPaginationModel}
//               loading={loading}
//             />
//           ) : (
//             !loading && (
//               <Box
//                 sx={{
//                   display: "flex",
//                   justifyContent: "center",
//                   alignItems: "center",
//                   height: 400,
//                   flexDirection: "column",
//                   gap: 2,
//                 }}
//               >
//                 <Avatar
//                   sx={{
//                     backgroundColor: alpha(medstownColors.primary, 0.1),
//                     color: medstownColors.primary,
//                     width: 64,
//                     height: 64,
//                   }}
//                 >
//                   <MdGroup size={32} />
//                 </Avatar>
//                 <Typography variant="h6" color="text.secondary">
//                   No users found
//                 </Typography>
//                 <Typography variant="body2" color="text.secondary">
//                   {searchText
//                     ? "Try adjusting your search terms"
//                     : "User data will appear here when available"}
//                 </Typography>
//               </Box>
//             )
//           )}
//         </Box>
//       </Card>

//       {/* Enhanced User Details Modal */}
//       <Modal open={open} onClose={handleClose}>
//         <Box
//           sx={{
//             position: "absolute",
//             top: "50%",
//             left: "50%",
//             transform: "translate(-50%, -50%)",
//             width: { xs: "95%", sm: "90%" },
//             height: "90vh",
//             bgcolor: "background.paper",
//             borderRadius: 3,
//             boxShadow: `0 24px 48px ${alpha(theme.palette.common.black, 0.15)}`,
//             overflow: "hidden",
//           }}
//         >
//           {/* Modal Header */}
//           <Box
//             sx={{
//               p: 3,
//               background: `linear-gradient(135deg, ${medstownColors.primary}, ${medstownColors.secondary})`,
//               color: "white",
//             }}
//           >
//             <Stack
//               direction="row"
//               alignItems="center"
//               justifyContent="space-between"
//             >
//               <Stack direction="row" alignItems="center" spacing={2}>
//                 <Avatar
//                   sx={{
//                     backgroundColor: alpha("#ffffff", 0.2),
//                     color: "white",
//                     width: 40,
//                     height: 40,
//                   }}
//                 >
//                   <MdInfo size={22} />
//                 </Avatar>
//                 <Box>
//                   <Typography variant="h5" fontWeight={800}>
//                     User Order Details
//                   </Typography>
//                   {selectedUserDetails && (
//                     <Typography variant="body2" sx={{ opacity: 0.9 }}>
//                       {selectedUserDetails?.customerName} - Complete order
//                       history
//                     </Typography>
//                   )}
//                 </Box>
//               </Stack>
//               <IconButton
//                 onClick={handleClose}
//                 sx={{
//                   color: "white",
//                   backgroundColor: alpha("#ffffff", 0.1),
//                   width: 40,
//                   height: 40,
//                 }}
//               >
//                 <MdClose size={22} />
//               </IconButton>
//             </Stack>
//           </Box>

//           {/* Modal Content */}
//           <Box sx={{ p: 3, height: "calc(100% - 100px)", overflowY: "auto" }}>
//             {selectedUserDetails ? (
//               <Grid container spacing={3}>
//                 {/* Air Orders */}
//                 <Grid item xs={12} md={6}>
//                   <Card sx={{ height: "100%", borderRadius: 2 }}>
//                     <Box
//                       sx={{
//                         p: 2,
//                         backgroundColor: alpha(medstownColors.warning, 0.1),
//                         borderBottom: `1px solid ${alpha(
//                           medstownColors.warning,
//                           0.2
//                         )}`,
//                       }}
//                     >
//                       <Stack direction="row" alignItems="center" spacing={1.5}>
//                         <Avatar
//                           sx={{
//                             backgroundColor: medstownColors.warning,
//                             color: "white",
//                             width: 32,
//                             height: 32,
//                           }}
//                         >
//                           <MdLocalPharmacy size={18} />
//                         </Avatar>
//                         <Typography
//                           variant="h6"
//                           fontWeight={700}
//                           sx={{ color: medstownColors.warning }}
//                         >
//                           Place Order Details (
//                           {selectedUserDetails?.airOrder?.length || 0})
//                         </Typography>
//                       </Stack>
//                     </Box>

//                     <Box
//                       sx={{
//                         p: 2,
//                         height: "calc(100% - 80px)",
//                         overflowY: "auto",
//                       }}
//                     >
//                       {selectedUserDetails?.airOrder?.map((item, index) => (
//                         <Accordion key={index} sx={{ mb: 1 }}>
//                           <AccordionSummary expandIcon={<MdExpandMore />}>
//                             <Stack
//                               direction="row"
//                               alignItems="center"
//                               spacing={2}
//                             >
//                               <Chip
//                                 label={item.status}
//                                 size="small"
//                                 sx={{
//                                   backgroundColor: alpha(
//                                     medstownColors.warning,
//                                     0.1
//                                   ),
//                                   color: medstownColors.warning,
//                                 }}
//                               />
//                               <Typography variant="body2" fontWeight={600}>
//                                 Order #{item.orderId}
//                               </Typography>
//                             </Stack>
//                           </AccordionSummary>
//                           <AccordionDetails>
//                             <Stack spacing={1}>
//                               <Typography variant="body2">
//                                 <strong>Customer:</strong> {item.customerName}
//                               </Typography>
//                               <Typography variant="body2">
//                                 <strong>Phone:</strong> {item.customerPhone}
//                               </Typography>
//                               <Typography variant="body2">
//                                 <strong>Pharmacy:</strong> {item.pharmacyName}
//                               </Typography>
//                               <Typography variant="body2">
//                                 <strong>Total:</strong> ₹{item.totalPrice}
//                               </Typography>
//                               <Typography variant="body2">
//                                 <strong>Date:</strong>{" "}
//                                 {dayjs(item.createdAt).format(
//                                   "MMM DD, YYYY HH:mm"
//                                 )}
//                               </Typography>

//                               {/* Order Items */}
//                               <Typography
//                                 variant="body2"
//                                 fontWeight={600}
//                                 sx={{ mt: 1 }}
//                               >
//                                 Items:
//                               </Typography>
//                               {item.orderDetails?.map((orderdata, i) => (
//                                 <Typography
//                                   key={i}
//                                   variant="caption"
//                                   sx={{ ml: 2 }}
//                                 >
//                                   • {orderdata.medicineName} (×
//                                   {orderdata.medicineQuantity}) - ₹
//                                   {orderdata.medicinePrice}
//                                 </Typography>
//                               ))}
//                             </Stack>
//                           </AccordionDetails>
//                         </Accordion>
//                       )) || (
//                         <Typography
//                           variant="body2"
//                           color="text.secondary"
//                           sx={{ textAlign: "center", py: 3 }}
//                         >
//                           No place orders found
//                         </Typography>
//                       )}
//                     </Box>
//                   </Card>
//                 </Grid>

//                 {/* Final Orders */}
//                 <Grid item xs={12} md={6}>
//                   <Card sx={{ height: "100%", borderRadius: 2 }}>
//                     <Box
//                       sx={{
//                         p: 2,
//                         backgroundColor: alpha(medstownColors.success, 0.1),
//                         borderBottom: `1px solid ${alpha(
//                           medstownColors.success,
//                           0.2
//                         )}`,
//                       }}
//                     >
//                       <Stack direction="row" alignItems="center" spacing={1.5}>
//                         <Avatar
//                           sx={{
//                             backgroundColor: medstownColors.success,
//                             color: "white",
//                             width: 32,
//                             height: 32,
//                           }}
//                         >
//                           <MdVerified size={18} />
//                         </Avatar>
//                         <Typography
//                           variant="h6"
//                           fontWeight={700}
//                           sx={{ color: medstownColors.success }}
//                         >
//                           Final Order Details (
//                           {selectedUserDetails?.finalorderdetal?.length || 0})
//                         </Typography>
//                       </Stack>
//                     </Box>

//                     <Box
//                       sx={{
//                         p: 2,
//                         height: "calc(100% - 80px)",
//                         overflowY: "auto",
//                       }}
//                     >
//                       {selectedUserDetails?.finalorderdetal?.map(
//                         (finalOrder, index) => (
//                           <Accordion key={index} sx={{ mb: 1 }}>
//                             <AccordionSummary expandIcon={<MdExpandMore />}>
//                               <Stack
//                                 direction="row"
//                                 alignItems="center"
//                                 spacing={2}
//                               >
//                                 <Chip
//                                   label={finalOrder.status}
//                                   size="small"
//                                   sx={{
//                                     backgroundColor: alpha(
//                                       medstownColors.success,
//                                       0.1
//                                     ),
//                                     color: medstownColors.success,
//                                   }}
//                                 />
//                                 <Typography variant="body2" fontWeight={600}>
//                                   Order #{finalOrder.orderId}
//                                 </Typography>
//                               </Stack>
//                             </AccordionSummary>
//                             <AccordionDetails>
//                               <Stack spacing={1}>
//                                 <Typography variant="body2">
//                                   <strong>Customer:</strong>{" "}
//                                   {finalOrder.customerName}
//                                 </Typography>
//                                 <Typography variant="body2">
//                                   <strong>Phone:</strong>{" "}
//                                   {finalOrder.customerPhone}
//                                 </Typography>
//                                 <Typography variant="body2">
//                                   <strong>Pharmacy:</strong>{" "}
//                                   {finalOrder?.pharmacyName}
//                                 </Typography>
//                                 <Typography variant="body2">
//                                   <strong>Payment:</strong>{" "}
//                                   {finalOrder.paymentType}
//                                 </Typography>
//                                 <Typography variant="body2">
//                                   <strong>Total:</strong> ₹
//                                   {finalOrder.totalPrice}
//                                 </Typography>
//                                 <Typography variant="body2">
//                                   <strong>OTP:</strong> {finalOrder.otpValue}
//                                 </Typography>
//                                 <Typography variant="body2">
//                                   <strong>Delivery:</strong>{" "}
//                                   {finalOrder.deliveryBoyName} -{" "}
//                                   {finalOrder.deliveryBoyPhone}
//                                 </Typography>
//                                 <Typography variant="body2">
//                                   <strong>Date:</strong>{" "}
//                                   {dayjs(finalOrder.createdAt).format(
//                                     "MMM DD, YYYY HH:mm"
//                                   )}
//                                 </Typography>

//                                 {/* Order Items */}
//                                 <Typography
//                                   variant="body2"
//                                   fontWeight={600}
//                                   sx={{ mt: 1 }}
//                                 >
//                                   Items:
//                                 </Typography>
//                                 {finalOrder.orderDetails?.map((order, i) => (
//                                   <Typography
//                                     key={i}
//                                     variant="caption"
//                                     sx={{ ml: 2 }}
//                                   >
//                                     • {order.medicineName} (×
//                                     {order.medicineQuantity}) - ₹
//                                     {order.medicinePrice}
//                                   </Typography>
//                                 ))}
//                               </Stack>
//                             </AccordionDetails>
//                           </Accordion>
//                         )
//                       ) || (
//                         <Typography
//                           variant="body2"
//                           color="text.secondary"
//                           sx={{ textAlign: "center", py: 3 }}
//                         >
//                           No final orders found
//                         </Typography>
//                       )}
//                     </Box>
//                   </Card>
//                 </Grid>
//               </Grid>
//             ) : (
//               <Box
//                 sx={{
//                   display: "flex",
//                   justifyContent: "center",
//                   alignItems: "center",
//                   height: "100%",
//                 }}
//               >
//                 <CircularProgress />
//               </Box>
//             )}
//           </Box>
//         </Box>
//       </Modal>

//       {/* Enhanced Delete Confirmation Modal */}
//       <Modal open={deleteOpen} onClose={handleDeleteClose}>
//         <Box
//           sx={{
//             position: "absolute",
//             top: "50%",
//             left: "50%",
//             transform: "translate(-50%, -50%)",
//             width: 500,
//             bgcolor: "background.paper",
//             borderRadius: 3,
//             boxShadow: `0 24px 48px ${alpha(theme.palette.common.black, 0.15)}`,
//             p: 4,
//           }}
//         >
//           <Stack direction="row" alignItems="center" spacing={3} sx={{ mb: 4 }}>
//             <Avatar
//               sx={{
//                 backgroundColor: alpha(medstownColors.error, 0.1),
//                 color: medstownColors.error,
//                 width: 48,
//                 height: 48,
//               }}
//             >
//               <MdError size={24} />
//             </Avatar>
//             <Box>
//               <Typography variant="h5" fontWeight={700} color="error.main">
//                 Delete User
//               </Typography>
//               <Typography variant="body1" color="text.secondary">
//                 This action cannot be undone
//               </Typography>
//             </Box>
//           </Stack>

//           <Typography variant="body1" sx={{ mb: 4 }}>
//             Are you sure you want to delete this user? All associated data
//             including order history will be permanently removed.
//           </Typography>

//           <Stack direction="row" spacing={3} justifyContent="flex-end">
//             <Button
//               variant="outlined"
//               size="large"
//               onClick={handleDeleteClose}
//               sx={{
//                 borderColor: alpha(medstownColors.error, 0.3),
//                 px: 4,
//                 py: 1.5,
//               }}
//             >
//               Cancel
//             </Button>
//             <Button
//               variant="contained"
//               color="error"
//               size="large"
//               onClick={handleDeleteUser}
//               startIcon={<MdDelete size={20} />}
//               sx={{
//                 px: 4,
//                 py: 1.5,
//               }}
//             >
//               Delete User
//             </Button>
//           </Stack>
//         </Box>
//       </Modal>

//       {/* Send Notification by Pin Code Modal */}
//       <Modal
//         open={sendnotificationopenmodel}
//         onClose={() => setSendnotificationopenmodel(false)}
//       >
//         <Box
//           sx={{
//             position: "absolute",
//             top: "50%",
//             left: "50%",
//             transform: "translate(-50%, -50%)",
//             width: "50%",
//             bgcolor: "background.paper",
//             boxShadow: 24,
//             borderRadius: 2,
//             p: 4,
//           }}
//         >
//           <SendnotificationByPinCode
//             sendnotificationopenmodel={sendnotificationopenmodel}
//             setSendnotificationopenmodel={setSendnotificationopenmodel}
//           />
//         </Box>
//       </Modal>

//       {/* Enhanced Notification Dialog */}
//       <Dialog
//         open={notifybox}
//         onClose={() => setNotifybox(false)}
//         fullWidth
//         maxWidth="md"
//       >
//         <DialogTitle
//           sx={{
//             background: `linear-gradient(135deg, ${medstownColors.primary}, ${medstownColors.secondary})`,
//             color: "white",
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "space-between",
//           }}
//         >
//           <Stack direction="row" alignItems="center" spacing={2}>
//             <Avatar
//               sx={{
//                 backgroundColor: alpha("#ffffff", 0.2),
//                 color: "white",
//                 width: 32,
//                 height: 32,
//               }}
//             >
//               <MdNotifications size={18} />
//             </Avatar>
//             <Typography variant="h6" fontWeight={700}>
//               Send Notification
//             </Typography>
//           </Stack>
//           <IconButton
//             onClick={() => setNotifybox(false)}
//             sx={{ color: "white" }}
//           >
//             <CloseIcon />
//           </IconButton>
//         </DialogTitle>

//         <DialogContent sx={{ p: 3 }}>
//           <Grid container spacing={2}>
//             <Grid item xs={12}>
//               <TextField
//                 label="Notification Title"
//                 name="title"
//                 value={formData?.title}
//                 onChange={handleChange}
//                 fullWidth
//                 margin="normal"
//                 InputProps={{
//                   startAdornment: (
//                     <InputAdornment position="start">
//                       <MdNotifications size={18} />
//                     </InputAdornment>
//                   ),
//                 }}
//               />
//             </Grid>
//             <Grid item xs={12}>
//               <TextField
//                 label="Message"
//                 name="msg"
//                 value={formData?.msg}
//                 onChange={handleChange}
//                 fullWidth
//                 margin="normal"
//                 multiline
//                 rows={3}
//                 InputProps={{
//                   startAdornment: (
//                     <InputAdornment position="start">
//                       <MdEdit size={18} />
//                     </InputAdornment>
//                   ),
//                 }}
//               />
//             </Grid>
//             <Grid item xs={12}>
//               <TextField
//                 label="Additional Details"
//                 name="details"
//                 value={formData?.details}
//                 onChange={handleChange}
//                 fullWidth
//                 margin="normal"
//                 multiline
//                 rows={4}
//                 variant="outlined"
//               />
//             </Grid>
//             <Grid item xs={12}>
//               <TextField
//                 label="Action URL (Optional)"
//                 name="urls"
//                 value={formData?.urls}
//                 onChange={handleChange}
//                 fullWidth
//                 margin="normal"
//                 placeholder="https://example.com"
//               />
//             </Grid>
//           </Grid>
//         </DialogContent>

//         <DialogActions sx={{ p: 3 }}>
//           <Button
//             onClick={() => setNotifybox(false)}
//             variant="outlined"
//             sx={{
//               borderColor: medstownColors.primary,
//               color: medstownColors.primary,
//             }}
//           >
//             Cancel
//           </Button>
//           <Button
//             onClick={handleSendNotification}
//             variant="contained"
//             startIcon={<MdNotifications size={18} />}
//             sx={{
//               backgroundColor: medstownColors.primary,
//               "&:hover": {
//                 backgroundColor: alpha(medstownColors.primary, 0.8),
//               },
//             }}
//           >
//             Send Notification
//           </Button>
//         </DialogActions>
//       </Dialog>
//     </Container>
//   );
// };

// export default UserDetails;

// import React, { useState, useEffect, useContext, useCallback } from "react";
// import { DataGrid } from "@mui/x-data-grid";
// import {
//   Modal,
//   TextField,
//   Box,
//   Typography,
//   Grid,
//   Paper,
//   Button,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   IconButton,
//   Snackbar,
//   Alert,
//   CircularProgress,
//   Card,
//   Stack,
//   Chip,
//   Avatar,
//   useTheme,
//   alpha,
//   LinearProgress,
//   Skeleton,
//   Container,
//   InputAdornment,
//   Tooltip,
//   useMediaQuery,
// } from "@mui/material";
// import {
//   MdSearch,
//   MdClear,
//   MdPerson,
//   MdPhone,
//   MdEmail,
//   MdLocationOn,
//   MdDelete,
//   MdInfo,
//   MdDownload,
//   MdNotifications,
//   MdAccountBalanceWallet,
//   MdCalendarToday,
//   MdAccessTime,
//   MdLocalPharmacy,
//   MdDeliveryDining,
//   MdPayment,
//   MdVerified,
//   MdFilterList,
//   MdGroup,
//   MdLocationCity,
//   MdTrendingUp,
// } from "react-icons/md";
// import { AiFillDelete } from "react-icons/ai";
// import { FaLocationArrow } from "react-icons/fa";
// import axios from "axios";
// import { MyContext } from "Contextapi/MyContext";
// import { useNavigate } from "react-router-dom";
// import CloseIcon from "@mui/icons-material/Close";
// import Usertotal from "./Usertotal";
// import HeatmapComponent from "./HeatmapComponent";
// import { toast } from "react-toastify";
// import SendnotificationByPinCode from "./SendnotificationByPinCode";
// import dayjs from "dayjs";

// const UserDetails = () => {
//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down("md"));
//   const navigate = useNavigate();
//   const { setUsercount } = useContext(MyContext);

//   const [usersData, setUsersData] = useState([]);
//   const [rowCount, setRowCount] = useState(0);
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState(null);

//   const [paginationModel, setPaginationModel] = useState({
//     page: 0,
//     pageSize: 10,
//   });

//   const [searchText, setSearchText] = useState("");
//   const [searchLoading, setSearchLoading] = useState(false);

//   const medstownColors = {
//     primary: "#014D4D",
//     secondary: "#02A0A0",
//     accent: "#FFB800",
//     success: "#4caf50",
//     error: "#f44336",
//     warning: "#ff9800",
//   };

//   // --- FETCH USERS ---
//   const fetchUsers = useCallback(async (pageNum = 1, limit = 10) => {
//     try {
//       setLoading(true);
//       const res = await axios.get(
//         `https://api.medstown.com/customer/users/list?page=${pageNum}&limit=${limit}`
//       );
//       setUsersData(res.data.data?.list || []);
//       setRowCount(res.data.data?.totalCount || 0);
//     } catch (error) {
//       console.error("Error fetching users:", error);
//       setError("Failed to load users");
//     } finally {
//       setLoading(false);
//     }
//   }, []);

//   useEffect(() => {
//     fetchUsers(paginationModel.page + 1, paginationModel.pageSize);
//   }, [fetchUsers, paginationModel.page, paginationModel.pageSize]);

//   // --- SEARCH LOGIC ---
//   const handleSearchTextChange = (event) => {
//     setSearchText(event.target.value);
//     setSearchLoading(true);
//     setTimeout(() => setSearchLoading(false), 300);
//   };

//   const clearSearch = () => setSearchText("");

//   const filteredRows = usersData.filter((row) =>
//     Object.values(row).some(
//       (value) =>
//         value &&
//         value.toString().toLowerCase().includes(searchText.toLowerCase())
//     )
//   );

//   // --- DELETE USER ---
//   const [deleteOpen, setDeleteOpen] = useState(false);
//   const [selectedUserId, setSelectedUserId] = useState(null);

//   const handleDeleteUser = async () => {
//     if (!selectedUserId) return;
//     try {
//       setLoading(true);
//       await axios.delete(
//         `https://api.medstown.com/customer/deleteuser/${selectedUserId}`
//       );
//       setUsersData((prev) =>
//         prev.filter((user) => user._id !== selectedUserId)
//       );
//       setUsercount((prev) => prev - 1);
//       toast.success("User deleted successfully.");
//     } catch (error) {
//       toast.error("Failed to delete user. Please try again.");
//     } finally {
//       setLoading(false);
//       setDeleteOpen(false);
//     }
//   };

//   // --- TABLE COLUMNS ---
//   const tableColumns = [
//     {
//       field: "fullName",
//       headerName: "User Details",
//       flex: 1,
//       renderCell: (params) => (
//         <Stack direction="row" alignItems="center" spacing={1}>
//           <Typography variant="body2" fontWeight={600}>
//             {params.value || "N/A"}
//           </Typography>
//         </Stack>
//       ),
//     },
//     {
//       field: "phone",
//       headerName: "Contact",
//       flex: 1,
//       renderCell: (params) => (
//         <Stack>
//           <Typography variant="body2" sx={{ fontSize: "0.8rem" }}>
//             {params.value || "N/A"}
//           </Typography>
//           <Typography variant="caption" color="text.secondary">
//             {params.row.email || ""}
//           </Typography>
//         </Stack>
//       ),
//     },
//     {
//       field: "pincode",
//       headerName: "Pincode",
//       width: 100,
//     },
//     {
//       field: "datetime",
//       headerName: "Registration Date",
//       width: 160,
//       renderCell: (params) =>
//         params.value ? dayjs(params.value).format("MMM DD, YYYY") : "N/A",
//     },
//     {
//       field: "Action",
//       headerName: "Actions",
//       width: 180,
//       renderCell: (params) => (
//         <Stack direction="row" spacing={1}>
//           <Tooltip title="View Location">
//             <IconButton
//               size="small"
//               onClick={() => {
//                 const lat = params?.row?.address?.latitude;
//                 const long = params?.row?.address?.longitude;
//                 if (lat && long)
//                   window.open(`https://www.google.com/maps?q=${lat},${long}`);
//               }}
//             >
//               <FaLocationArrow size={14} />
//             </IconButton>
//           </Tooltip>
//           <Tooltip title="User Activity">
//             <IconButton
//               size="small"
//               onClick={() =>
//                 navigate(`/admin/user-activity/${params.row.userId}`)
//               }
//             >
//               <MdTrendingUp size={16} />
//             </IconButton>
//           </Tooltip>
//           <Tooltip title="Delete User">
//             <IconButton
//               size="small"
//               onClick={() => {
//                 setSelectedUserId(params.row._id);
//                 setDeleteOpen(true);
//               }}
//             >
//               <AiFillDelete size={16} color="red" />
//             </IconButton>
//           </Tooltip>
//         </Stack>
//       ),
//     },
//   ];

//   return (
//     <Container maxWidth="xl" sx={{ py: 2 }}>

//       {/* Memoized Components */}
//       <Usertotal />
//       <HeatmapComponent />
//       <Paper
//         elevation={0}
//         sx={{
//           p: 2,
//           mb: 2,
//           background: `linear-gradient(135deg, ${medstownColors.primary}, ${medstownColors.secondary})`,
//           color: "white",
//           borderRadius: 2,
//         }}
//       >
//         <Typography variant="h5" fontWeight={700}>
//           User Management Hub
//         </Typography>
//       </Paper>

//       {/* Search Bar */}
//       <TextField
//         fullWidth
//         variant="outlined"
//         placeholder="Search users..."
//         size="small"
//         value={searchText}
//         onChange={handleSearchTextChange}
//         InputProps={{
//           startAdornment: (
//             <InputAdornment position="start">
//               {searchLoading ? (
//                 <LinearProgress sx={{ width: 18, height: 2 }} />
//               ) : (
//                 <MdSearch />
//               )}
//             </InputAdornment>
//           ),
//           endAdornment: searchText && (
//             <InputAdornment position="end">
//               <IconButton size="small" onClick={clearSearch}>
//                 <MdClear />
//               </IconButton>
//             </InputAdornment>
//           ),
//         }}
//         sx={{ mb: 2 }}
//       />

//       {/* Table */}
//       <Card sx={{ borderRadius: 2 }}>
//         <Box sx={{ p: 2 }}>
//           <DataGrid
//             rows={filteredRows}
//             columns={tableColumns}
//             getRowId={(row) => row._id}
//             paginationMode="server"
//             rowCount={rowCount}
//             pageSizeOptions={[5, 10, 20]}
//             paginationModel={paginationModel}
//             onPaginationModelChange={(model) =>
//               setPaginationModel((prev) =>
//                 prev.page !== model.page || prev.pageSize !== model.pageSize
//                   ? model
//                   : prev
//               )
//             }
//             loading={loading}
//           />
//         </Box>
//       </Card>

//       {/* Delete Modal */}
//       <Modal open={deleteOpen} onClose={() => setDeleteOpen(false)}>
//         <Box
//           sx={{
//             position: "absolute",
//             top: "50%",
//             left: "50%",
//             transform: "translate(-50%, -50%)",
//             bgcolor: "background.paper",
//             p: 3,
//             borderRadius: 2,
//           }}
//         >
//           <Typography variant="h6" mb={2}>
//             Are you sure you want to delete this user?
//           </Typography>
//           <Stack direction="row" spacing={2} justifyContent="flex-end">
//             <Button onClick={() => setDeleteOpen(false)}>Cancel</Button>
//             <Button variant="contained" color="error" onClick={handleDeleteUser}>
//               Delete
//             </Button>
//           </Stack>
//         </Box>
//       </Modal>

//       {/* Notification Modal */}
//       <Snackbar
//         open={!!error}
//         autoHideDuration={4000}
//         onClose={() => setError(null)}
//       >
//         <Alert severity="error">{error}</Alert>
//       </Snackbar>

//     </Container>
//   );
// };

// export default React.memo(UserDetails);

import React, { useState, useEffect, useContext, useCallback } from "react";
import { DataGrid } from "@mui/x-data-grid";
import {
  Modal,
  TextField,
  Box,
  Typography,
  Grid,
  Paper,
  Button,
  IconButton,
  Snackbar,
  Alert,
  Card,
  Stack,
  Avatar,
  useTheme,
  alpha,
  LinearProgress,
  Container,
  InputAdornment,
  Tooltip,
  useMediaQuery,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import {
  MdSearch,
  MdClear,
  MdPerson,
  MdPhone,
  MdEmail,
  MdLocationOn,
  MdDelete,
  MdTrendingUp,
  MdGroup,
  MdDownload,
  MdNotifications,
  MdAccountBalanceWallet,
  MdLocationCity,
  MdEdit,
} from "react-icons/md";
import { AiFillDelete } from "react-icons/ai";
import { FaLocationArrow } from "react-icons/fa";
import axios from "axios";
import { MyContext } from "Contextapi/MyContext";
import { useNavigate } from "react-router-dom";
import dayjs from "dayjs";
import Usertotal from "./Usertotal";
import HeatmapComponent from "./HeatmapComponent";
import { toast } from "react-toastify";
import SendNotificationByPinCode from "./SendnotificationByPinCode";
// import CloseIcon from "components/icons/CloseIcon";

const UserDetails = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const { setUsercount } = useContext(MyContext);

  const [usersData, setUsersData] = useState([]);
  const [rowCount, setRowCount] = useState(0);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 10,
  });
  const [searchText, setSearchText] = useState("");
  const [searchLoading, setSearchLoading] = useState(false);
  const [deleteOpen, setDeleteOpen] = useState(false);
  const [selectedUserId, setSelectedUserId] = useState(null);
  const [sendnotificationopenmodel, setSendnotificationopenmodel] =
    useState(false);
  const [formData, setFormData] = useState({
    msg: "",
    title: "",
    details: "",
    urls: "",
  });
  const [notifybox, setNotifybox] = useState(false);

  const medstownColors = {
    primary: "#014D4D",
    secondary: "#02A0A0",
    accent: "#FFB800",
    success: "#4caf50",
    error: "#f44336",
    warning: "#ff9800",
  };

  // --- FETCH USERS (Server-side pagination + search) ---
  const fetchUsers = useCallback(
    async (pageNum = 1, limit = 10, search = "") => {
      try {
        setLoading(true);
        const res = await axios.get(
          `https://api.medstown.com/customer/users/list?page=${pageNum}&limit=${limit}&search=${search}`
        );
        setUsersData(res.data.data?.list || []);
        setRowCount(res.data.data?.totalCount || 0);
      } catch (err) {
        console.error("Error fetching users:", err);
        setError("Failed to fetch users");
      } finally {
        setLoading(false);
      }
    },
    []
  );

  useEffect(() => {
    fetchUsers(paginationModel.page + 1, paginationModel.pageSize, searchText);
  }, [fetchUsers, paginationModel.page, paginationModel.pageSize, searchText]);

  // --- SEARCH FUNCTIONALITY ---
  const handleSearchTextChange = (e) => {
    const value = e.target.value;
    setSearchText(value);
    setSearchLoading(true);
    setTimeout(() => setSearchLoading(false), 300);
  };

  const clearSearch = () => setSearchText("");

  // --- DELETE USER ---
  const handleDeleteUser = async () => {
    try {
      await axios.delete(
        `https://api.medstown.com/customer/deleteuser/${selectedUserId}`
      );
      toast.success("User deleted successfully.");
      setUsersData((prev) => prev.filter((u) => u._id !== selectedUserId));
      setUsercount((prev) => prev - 1);
      setDeleteOpen(false);
    } catch {
      toast.error("Failed to delete user.");
    }
  };

  const handleDownload = () => {
    try {
      window.location.href =
        "https://api.medstown.com/admin/users/download-csv";
    } catch (error) {
      setError("Failed to download CSV");
      console.error("Download error:", error);
    }
  };

  const tableColumns = [
    {
      field: "fullName",
      headerName: "User Details",
      flex: 1,
      renderCell: (params) => (
        <Stack direction="row" alignItems="center" spacing={1}>
          <Box>
            <Typography variant="body2" fontWeight={600}>
              {params.value || "N/A"}
            </Typography>
            {/* <Typography variant="caption" color="text.secondary">
              ID: {params.row.userId}
            </Typography> */}
          </Box>
        </Stack>
      ),
    },
    {
      field: "phone",
      headerName: "Contact",
      flex: 1,
      renderCell: (params) => (
        <Stack>
          <Typography variant="body2">{params.value || "N/A"}</Typography>
          <Typography variant="caption" color="text.secondary">
            {params.row.email || ""}
          </Typography>
        </Stack>
      ),
    },
    {
      field: "pincode",
      headerName: "Pincode",
      flex: 1,
      renderCell: (params) => (
        <Typography sx={{ fontWeight: 500 }}>
          {params.value || "N/A"}
        </Typography>
      ),
    },
    {
      field: "address",
      headerName: "Location",
      flex: 2,
      renderCell: (params) => (
        <Stack direction="row" alignItems="center" spacing={1}>
          {/* <MdLocationOn size={14} color={medstownColors.secondary} /> */}
          <Typography
            variant="body2"
            sx={{
              fontSize: "0.75rem",
              overflow: "hidden",
              textOverflow: "ellipsis",
              display: "-webkit-box",
              WebkitLineClamp: 2,
              WebkitBoxOrient: "vertical",
            }}
          >
            {params?.row?.address
              ? `${params?.row?.address?.street || ""} ${
                  params?.row?.address?.district || ""
                } ${params?.row?.address?.city || ""} ${
                  params?.row?.address?.region || ""
                } ${params?.row?.address?.postalCode || ""}`
              : "N/A"}
          </Typography>
        </Stack>
      ),
    },
    {
      field: "datetime",
      headerName: "Registration",
      flex: 1,
      renderCell: (params) => {
        const date = new Date(params.value || null);
        return (
          <Stack spacing={0.3}>
            <Stack direction="row" alignItems="center" spacing={0.5}>
              {/* <MdCalendarToday size={12} color={theme.palette.text.secondary} /> */}
              <Typography
                variant="caption"
                sx={{ fontSize: "0.7rem", fontWeight: 500 }}
              >
                {date ? dayjs(date).format("MMM DD, YYYY") : "N/A"}
              </Typography>
            </Stack>
            <Stack direction="row" alignItems="center" spacing={0.5}>
              {/* <MdAccessTime size={12} color={theme.palette.text.secondary} /> */}
              <Typography
                variant="caption"
                sx={{
                  fontSize: "0.65rem",
                  color: "text.secondary",
                }}
              >
                {date ? dayjs(date).format("hh:mm A") : "N/A"}
              </Typography>
            </Stack>
          </Stack>
        );
      },
    },
    {
      field: "Action",
      headerName: "Actions",
      flex: 1,
      renderCell: (params) => (
        <Stack direction="row" spacing={1}>
          <Tooltip title="User Activity">
            <IconButton
              size="small"
              onClick={() =>
                navigate(`/admin/user-activity/${params.row.userId}`)
              }
              sx={{
                color: medstownColors.secondary,
                backgroundColor: alpha(medstownColors.secondary, 0.1),
              }}
            >
              <MdTrendingUp size={16} />
            </IconButton>
          </Tooltip>

          <Tooltip title="View Location">
            <IconButton
              size="small"
              onClick={() => {
                const lat = params.row?.address?.latitude;
                const lng = params.row?.address?.longitude;
                if (lat && lng)
                  window.open(`https://www.google.com/maps?q=${lat},${lng}`);
              }}
              sx={{
                color: medstownColors.accent,
                backgroundColor: alpha(medstownColors.accent, 0.1),
              }}
            >
              <FaLocationArrow size={14} />
            </IconButton>
          </Tooltip>

          <Tooltip title="Delete User">
            <IconButton
              size="small"
              onClick={() => {
                setSelectedUserId(params.row._id);
                setDeleteOpen(true);
              }}
              sx={{
                color: medstownColors.error,
                backgroundColor: alpha(medstownColors.error, 0.1),
              }}
            >
              <AiFillDelete size={14} />
            </IconButton>
          </Tooltip>
        </Stack>
      ),
    },
  ];

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSendNotification = async () => {
    if (!searchText.match(/^\d{6}$/)) {
      setError("Please enter a valid 6-digit pincode");
      return;
    }
    try {
      await axios.post(
        `https://api.medstown.com/customer/userspincode/${searchText}/notiy`,
        formData
      );
      setFormData({
        msg: "",
        title: "",
        details: "",
        urls: "",
      });
      setNotifybox(false);
      setError(null);
      alert(`Notification is running successfully pincode-${searchText}`);
    } catch (error) {
      setError(error.response?.data?.message || "Failed to send notification");
    }
  };
  return (
    <Container maxWidth="xl" sx={{ py: 3 }}>
      {/* HEADER */}
      <Paper
        elevation={0}
        className="shadow-md"
        sx={{
          p: 3,
          mb: 3,
          borderRadius: 3,
          background: `linear-gradient(135deg, ${medstownColors.primary}, ${medstownColors.secondary})`,
          color: "white",
        }}
      >
        <Stack direction="row" alignItems="center" spacing={2}>
          <Avatar
            sx={{
              backgroundColor: alpha("#fff", 0.2),
              color: "#fff",
              width: 46,
              height: 46,
            }}
          >
            <MdGroup size={28} />
          </Avatar>
          <Box>
            <Typography variant="h4" fontWeight={800}>
              User Management Hub
            </Typography>
            <Typography variant="body2" sx={{ opacity: 0.8 }}>
              Manage, search, and monitor users efficiently
            </Typography>
          </Box>
        </Stack>
      </Paper>

      {/* Tailwind-Like Stats */}
      {/* <Grid container spacing={2} sx={{ mt: 2 }}> */}
      <Usertotal />
      <div style={{ height: 20 }} />
      <HeatmapComponent />
      <div style={{ height: 20 }} />

      {/* </Grid> */}

      {/* Actions and Search */}
      <Card
        elevation={2}
        sx={{
          mb: 3,
          borderRadius: 2,
          p: 2,
          border: `1px solid ${alpha(medstownColors.primary, 0.08)}`,
        }}
      >
        <Stack
          direction={isMobile ? "column" : "row"}
          spacing={2}
          justifyContent="space-between"
        >
          <TextField
            variant="outlined"
            placeholder="Search name, phone, email..."
            // fullWidth
            sx={{ width: "50%" }}
            size="small"
            value={searchText}
            onChange={handleSearchTextChange}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  {searchLoading ? (
                    <LinearProgress
                      sx={{ height: 2, width: 18, borderRadius: 2 }}
                    />
                  ) : (
                    <MdSearch color={medstownColors.primary} />
                  )}
                </InputAdornment>
              ),
              endAdornment: searchText && (
                <InputAdornment position="end">
                  <IconButton size="small" onClick={clearSearch}>
                    <MdClear />
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />

          <Button
            variant="contained"
            startIcon={<MdDownload size={16} />}
            onClick={() => handleDownload()}
            sx={{
              backgroundColor: medstownColors.primary,
              "&:hover": {
                backgroundColor: alpha(medstownColors.primary, 0.8),
              },
              borderRadius: 2,
              px: 2,
              py: 1,
            }}
          >
            CSV
          </Button>
          <Button
            variant="contained"
            startIcon={<MdNotifications size={16} />}
            onClick={() => setNotifybox(true)}
            sx={{
              backgroundColor: medstownColors.secondary,
              "&:hover": {
                backgroundColor: alpha(medstownColors.secondary, 0.8),
              },
              borderRadius: 2,
              px: 2,
              py: 1,
            }}
          >
            Notify
          </Button>
          <Button
            variant="contained"
            startIcon={<MdAccountBalanceWallet size={16} />}
            onClick={() => navigate("/admin/add-wallet-amount")}
            sx={{
              backgroundColor: medstownColors.accent,
              "&:hover": {
                backgroundColor: alpha(medstownColors.accent, 0.8),
              },
              borderRadius: 2,
              px: 2,
              py: 1,
              color: "white",
            }}
          >
            Add Cash
          </Button>
          <Button
            variant="contained"
            startIcon={<MdLocationCity size={16} />}
            onClick={() => setSendnotificationopenmodel(true)}
            sx={{
              backgroundColor: medstownColors.success,
              "&:hover": {
                backgroundColor: alpha(medstownColors.success, 0.8),
              },
              borderRadius: 2,
              px: 2,
              py: 1,
            }}
          >
            Pin Notify
          </Button>
        </Stack>
      </Card>

      {/* DATAGRID */}
      <Card>
        <Box sx={{ height: 600, p: 2 }}>
          <DataGrid
            rows={usersData}
            columns={tableColumns}
            getRowId={(row) => row._id}
            paginationMode="server"
            rowCount={rowCount}
            pageSizeOptions={[5, 10, 20]}
            paginationModel={paginationModel}
            onPaginationModelChange={setPaginationModel}
            loading={loading}
          />
        </Box>
      </Card>

      {/* Delete Confirmation Modal */}
      <Modal open={deleteOpen} onClose={() => setDeleteOpen(false)}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            bgcolor: "background.paper",
            p: 4,
            borderRadius: 2,
            boxShadow: 6,
          }}
        >
          <Typography variant="h6" gutterBottom>
            Confirm Delete
          </Typography>
          <Typography variant="body2" gutterBottom>
            Are you sure you want to delete this user?
          </Typography>
          <Stack direction="row" justifyContent="flex-end" spacing={2}>
            <Button onClick={() => setDeleteOpen(false)}>Cancel</Button>
            <Button
              variant="contained"
              color="error"
              onClick={handleDeleteUser}
            >
              Delete
            </Button>
          </Stack>
        </Box>
      </Modal>

      {/* Error Popup */}
      <Snackbar
        open={!!error}
        autoHideDuration={5000}
        onClose={() => setError(null)}
      >
        <Alert severity="error">{error}</Alert>
      </Snackbar>
      {/* Send Notification by Pin Code Modal */}
      <Modal
        open={sendnotificationopenmodel}
        onClose={() => setSendnotificationopenmodel(false)}
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "50%",
            bgcolor: "background.paper",
            boxShadow: 24,
            borderRadius: 2,
            p: 4,
          }}
        >
          <SendNotificationByPinCode
            sendnotificationopenmodel={sendnotificationopenmodel}
            setSendnotificationopenmodel={setSendnotificationopenmodel}
          />
        </Box>
      </Modal>

      {/* Enhanced Notification Dialog */}
      <Dialog
        open={notifybox}
        onClose={() => setNotifybox(false)}
        fullWidth
        maxWidth="md"
      >
        <DialogTitle
          sx={{
            background: `linear-gradient(135deg, ${medstownColors.primary}, ${medstownColors.secondary})`,
            color: "white",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Stack direction="row" alignItems="center" spacing={2}>
            <Avatar
              sx={{
                backgroundColor: alpha("#ffffff", 0.2),
                color: "white",
                width: 32,
                height: 32,
              }}
            >
              <MdNotifications size={18} />
            </Avatar>
            <Typography variant="h6" fontWeight={700}>
              Send Notification
            </Typography>
          </Stack>
          <IconButton
            onClick={() => setNotifybox(false)}
            sx={{ color: "white" }}
          >
            x{/* <CloseIcon /> */}
          </IconButton>
        </DialogTitle>

        <DialogContent sx={{ p: 3 }}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField
                label="Notification Title"
                name="title"
                value={formData?.title}
                onChange={handleChange}
                fullWidth
                margin="normal"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <MdNotifications size={18} />
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                label="Message"
                name="msg"
                value={formData?.msg}
                onChange={handleChange}
                fullWidth
                margin="normal"
                multiline
                rows={3}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <MdEdit size={18} />
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                label="Additional Details"
                name="details"
                value={formData?.details}
                onChange={handleChange}
                fullWidth
                margin="normal"
                multiline
                rows={4}
                variant="outlined"
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                label="Action URL (Optional)"
                name="urls"
                value={formData?.urls}
                onChange={handleChange}
                fullWidth
                margin="normal"
                placeholder="https://example.com"
              />
            </Grid>
          </Grid>
        </DialogContent>

        <DialogActions sx={{ p: 3 }}>
          <Button
            onClick={() => setNotifybox(false)}
            variant="outlined"
            sx={{
              borderColor: medstownColors.primary,
              color: medstownColors.primary,
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleSendNotification}
            variant="contained"
            startIcon={<MdNotifications size={18} />}
            sx={{
              backgroundColor: medstownColors.primary,
              "&:hover": {
                backgroundColor: alpha(medstownColors.primary, 0.8),
              },
            }}
          >
            Send Notification
          </Button>
        </DialogActions>
      </Dialog>
    </Container>
  );
};

export default React.memo(UserDetails);
